import * as React from "react";
import * as PropTypes from 'prop-types';
import {ToolbarDataContext} from "../contexts/toolbar-context";
import {Button, ButtonGroup, Icon, styled, Tooltip, Typography} from "@mui/material";
import SaveIcon from '@mui/icons-material/Save';
import AddIcon from '@mui/icons-material/Add';
import GridViewIcon from '@mui/icons-material/GridView';
import ViewListIcon from '@mui/icons-material/ViewList';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import DownloadIcon from '@mui/icons-material/Download';
import SearchIcon from '@mui/icons-material/Search';
import {Email, Remove, ViewColumn} from "@mui/icons-material";


/*
setToolbar([searchbutton][newbutton] [title])
^ through
setToolbar([searchbutton][newbutton] [new title] [savebutton])
 */
const icons = {
  save: <SaveIcon/>,
  'file-add': <AddIcon/>,
  'grid-view': <GridViewIcon/>,
  'list': <ViewListIcon/>,
  'duplicate': <ContentCopyIcon/>,
  'download': <DownloadIcon/>,
  'search': <SearchIcon/>,
  envelope: <Email/>,
  plus: <AddIcon/>,
  minus: <Remove/>,
  columns: <ViewColumn/>
};


const PageTitle = styled('div', {
  name: 'Toolbar', slot: 'title',
  shouldForwardProp: (prop) =>
      prop !== 'colour' && prop !== 'variant' && prop !== 'sx',
  overridesResolver: (props, styles) => [
    styles.title
  ],
})({});

const Toolbar = ()=> {
  let toolbar = React.useContext(ToolbarDataContext);
  if(!toolbar) {
    toolbar = {
      primaryUrl: "", secondaryUrl: undefined,
      primary:[],secondary:[],title:'Hollywood 2'
    };
  }
  let idx = 0;
  let toolbarSecondary = null,toolbarMain = null;
  if(toolbar.primary) {
    toolbarMain = toolbar.primary.map(function (val) {
      if (!val) return;

      if (val.type === 'button') {
        const icon = val.icon && icons[val.icon] ? icons[val.icon] : val.icon;
        return <Tooltip key={idx++} title={val.icon?val.label:(val.tooltip??'')}>
          <Button variant="contained"
                  onClick={val.callback}
                  disabled={val.disabled}
                  className={val.className || ''}
          >{val.icon?icon:(val.label??'')}</Button>
        </Tooltip>;
      }
    });
  }
  const toolbarTitle = <PageTitle>{toolbar.title}</PageTitle>;
  if(toolbar.secondary) {
    toolbarSecondary = toolbar.secondary.map(function (val) {
      if (!val) return;
      if (val.type === 'button') {
        const icon = val.icon && icons[val.icon] ? icons[val.icon] : val.icon;
        return <Tooltip key={idx++} title={val.icon?val.label:val.tooltip}><Button variant={val.disabled?'text':'contained'}
                                                                onClick={val.callback}
                                                                disabled={val.disabled}

                                                                className={val.className || ''}
        >{val.icon?icon:(val.label??'')}</Button></Tooltip>;
      }
    });
  }
  return (

    <div className="hly-toolbar">
      <div className="hly-toolbar__left"><ButtonGroup size="large">{toolbarMain}</ButtonGroup></div>
      <Typography className="hly-toolbar__center" variant="h6">{toolbarTitle}</Typography>
      <div className="hly-toolbar__right"><ButtonGroup size="large">{toolbarSecondary}</ButtonGroup></div>
    </div>
  )
}


/*
class Toolbar extends React.PureComponent {
  constructor(props) {
    super(props);
  }
  render() {
    var idx=0;
    console.log('render toolbar?',this.props.toolbarContext.toolbar.title);
    var toolbar = this.props.toolbarContext.toolbar;
    if(!toolbar) {
      toolbar = {
        primary:[],secondary:[],title:'Hollywood 2'
      };
    }
    if(toolbar.primary) {
      var toolbarMain = toolbar.primary.map(function (val) {
        if (val.type === 'button') {
          return <Tooltip key={idx++} title={val.tooltip}><Button ghost={!val.noGhost} icon={val.icon}
                                                                  onClick={val.callback}
                                                                  disabled={val.disabled}
                                                                  type={val.style ? val.style : null}>{val.label ? ' ' + val.label : ''}</Button></Tooltip>;
        }
      });
    }
    var toolbarTitle =<h2 key="title">{toolbar.title}</h2>;
    if(toolbar.secondary) {
      var toolbarSecondary = toolbar.secondary.map(function (val) {
        if (val.type === 'button') {
          return <Tooltip key={idx++} title={val.tooltip}><Button ghost={!val.noGhost} icon={val.icon}
                                                                  onClick={val.callback}
                                                                  disabled={val.disabled}
                                                                  type={val.style ? val.style : null}>{val.label ? ' ' + val.label : ''}</Button></Tooltip>;
        }
      });
    }
    return (
      <Row className="toolbar" type="flex" gutter={8}>
        <Col span={6} className="toolbar__primary"><Button.Group>{toolbarMain}</Button.Group></Col>
        <Col span={12} className="toolbar__title">{toolbarTitle}</Col>
        <Col span={6} className="toolbar__secondary"><Button.Group>{toolbarSecondary}</Button.Group></Col>
      </Row>
    )
  }
}
*/
Toolbar.propTypes = {
  primary:PropTypes.array,
  title:PropTypes.string,
  secondary:PropTypes.array
};

export default Toolbar;
//export default withToolbarContextValue(Toolbar);